exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgotten-password-form[data-v-ffe45584] {\n  text-align: left;\n}\n.forgotten-password-content-row[data-v-ffe45584] {\n  margin-top: 10vh;\n}\n.forgotten-password-card-container[data-v-ffe45584] {\n  background-color: white;\n  max-width: 600px;\n  text-align: center;\n  margin: auto;\n  padding-top: 48px;\n  padding-bottom: 38px;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n.back-button-holder[data-v-ffe45584] {\n  margin-top: 35px;\n  text-align: left;\n}\n.forgotten-password-form-button[data-v-ffe45584] {\n  width: 100%;\n}\n", ""]);

// exports
